import { required } from '@jfs/ui-new'
import { numberValidationNonZero } from '@jfs/ui-new/src/utils/validations'
import { numberValidation } from '@jfs/utils'
import * as Yup from 'yup'
import { TitleWithDashedLine } from '../../../../components/TitleWithDashedLine'
import { getDescriptionFromLOVValue, getValueFromLOVDescription } from '../../../../utils'
import { LimitTableComp } from '../../../EntityManagement/Onboarding/RiskSettings/LimitsTable/LimitTableComp'
import { DropdownWithInfo } from '../comps/DropdownWithInfo'
import { TextInputWithInfo } from '../comps/TextInputWithInfo'
import { allowRiskTip, getDropdownData, merchantRiskCategoary } from './dropdownData'
import { styles } from './styles'

const hidedefferedDeliveryOption = (lovData: any) => (values: any) =>
  getValueFromLOVDescription(lovData, values?.businessChannel, 'BusinessChannel') !== '1' ||
  getValueFromLOVDescription(lovData, values?.riskDeliveryPeriod, 'DeliveryMode') !== 'D'

const hideNonOnline = (lovData: any) => (values: any) =>
  getValueFromLOVDescription(lovData, values?.businessChannel, 'BusinessChannel') !== '1'

const currentTnxLimitValidation = Yup.string()
  .trim()
  .required('Required.')
  .min(1, 'Please enter a number')
  .matches(/^[0-9]*$/, 'Only digits 0-9 are allowed.')
  .test('is-positive-number', 'Value must be a number greater than 0', (value) => {
    // Check if the value is a number and greater than 0
    return value !== undefined && value !== null && !isNaN(value) && Number(value) > 0
  })
  .test(
    'is-greater',
    'Current transaction limit should be greater than or equal to  exit limit',
    function (value, ...extraData) {
      const { riskCurrentExitLimit } = this.parent
      return +value >= +riskCurrentExitLimit
    },
  )

export const riskSettingForm = (dropDownData: any, editable: boolean, initialValues: any) => ({
  key: 'RISK_SETTINGS_FORM',
  verticalFlex: 1,
  contentOverflow: 'auto',
  horizontalFlex: 1,
  contentPadding: 24,
  title: 'Risk Settings',
  formItems: [
    {
      fieldName: 'riskConfigLabel',
      ComponentName: TitleWithDashedLine,
      title: 'Configurations',
    },
    {
      horizontalComps: [
        {
          fieldName: 'merchantRiskCategory',
          ComponentName: DropdownWithInfo,
          ...styles.dropDownStyle(editable),
          validationSchema: required,
          label: 'Merchant Risk',
          title: 'Select Risk',
          data: merchantRiskCategoary,
          defaultEditableValue: 'NON-TRUSTED',
        },
        {
          fieldName: 'riskInternationalAcceptance',
          ComponentName: DropdownWithInfo,
          ...styles.dropDownStyle(editable),
          defaultEditableValue: 'No',
          validationSchema: required,
          label: 'International Acceptance',
          title: 'Select Acceptance',
          data: allowRiskTip,
        },
      ],
    },
    {
      horizontalComps: [
        {
          fieldName: 'riskDeliveryPeriod',
          ComponentName: DropdownWithInfo,
          ...styles.dropDownStyle(editable),
          validationSchema: required,
          defaultEditableValue: getDescriptionFromLOVValue(dropDownData?.lovData, 'DeliveryMode', 'I'),
          label: 'Delivery Period',
          title: 'Select Delivery Period',
          hideComponent: hideNonOnline(dropDownData?.lovData),
          data: getDropdownData(dropDownData?.lovData, 'DeliveryMode'),
          dataFieldToRead: 'description',
        },
        {
          fieldName: 'riskDeferredDeliveryOptions',
          ComponentName: DropdownWithInfo,
          label: 'Defferred Delivery Options',
          title: 'Select Defferred Delivery Options',
          validationSchema: required,
          selectable: editable,
          data: getDropdownData(dropDownData?.lovData, 'DeferredDeliveryOptions'),
          hideComponent: hidedefferedDeliveryOption(dropDownData?.lovData),
          dataFieldToRead: 'description',
          ...styles.dropDownStyle(editable),
          testID: 'deferredDeliveryOptions',
        },
      ],
    },
    {
      fieldName: 'limitsLabel',
      ComponentName: TitleWithDashedLine,
      title: 'Limits',
    },
    {
      horizontalComps: [
        {
          fieldName: 'riskCurrentTnxLimit',
          ComponentName: TextInputWithInfo,
          label: 'Updated Current Transaction Limit (Rs.)',
          placeholder: 'Transaction Limit',
          validationSchema: currentTnxLimitValidation,
          ...styles.textinputStyle(editable),
          hide: !editable && !initialValues?.changeHistory?.riskCurrentTnxLimit,
        },
        {
          fieldName: 'riskCurrentExitLimit',
          ComponentName: TextInputWithInfo,
          label: 'Updated Exit Limit (Rs.)',
          placeholder: 'Exit Limit',
          validationSchema: numberValidationNonZero,
          hide: !editable && !initialValues?.changeHistory?.riskCurrentExitLimit,
          ...styles.textinputStyle(editable),
        },
        {
          fieldName: 'riskCurrentTnxCount',
          ComponentName: TextInputWithInfo,
          label: 'Updated Current Transaction count',
          placeholder: 'Transaction count',
          validationSchema: numberValidation,
          hide: !editable && !initialValues?.changeHistory?.riskCurrentTnxCount,
          ...styles.textinputStyle(editable),
        },
      ],
    },
    {
      fieldName: 'limitTableData',
      ComponentName: LimitTableWrapper,
    },
  ],
  onSubmit: async (values) => {},
})

const LimitTableWrapper = (props: any) => {
  console.log('props=', props)
  const dataList = props?.allValues?.[props?.fieldName] ?? [
    {
      current: 'NA',
      previous: 'NA',
      older: 'NA',
      recruitment: 'NA',
    },
    {
      current: 'NA',
      previous: 'NA',
      older: 'NA',
      recruitment: 'NA',
    },
    {
      current: 'NA',
      previous: 'NA',
      older: 'NA',
      recruitment: 'NA',
    },
    {
      current: 'NA',
      previous: 'NA',
      older: 'NA',
      recruitment: 'NA',
    },
  ]
  dataList[0].current = props?.allValues?.riskCurrentTnxLimit
  dataList[1].current = props?.allValues?.riskCurrentExitLimit
  dataList[2].current = props?.allValues?.riskCurrentTnxCount

  return (
    <LimitTableComp
      selectedLoop={'Open Loop'}
      loopData={[{ id: 1, value: 'Open Loop' }]}
      onLoopChange={() => {}}
      dataList={dataList}
      isSearchFlow={true}
      onRowPress={() => {}}
      selectedData={() => {}}
    />
  )
}
